import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { TFileCatalog, TFileState } from '~/store/file/file.type';

const initialState: TFileState = {
  oneBookFiles: [],
  tikuFiles: [],
  flashFiles: [],
  fileCatalog: {},
  searchCondition: {
    eduCodes: null,
    years: null,
    grades: null,
    subjects: null,
  },
};

export const fileSlice = createSlice({
  name: 'file',
  initialState,
  reducers: {
    setOneBookFiles: (state, action: PayloadAction<string[]>) => {
      state.oneBookFiles = action.payload;
    },
    setTikuFiles: (state, action: PayloadAction<string[]>) => {
      state.tikuFiles = action.payload;
    },
    setFlashFiles: (state, action: PayloadAction<string[]>) => {
      state.flashFiles = action.payload;
    },
    setFileCatalog: (state, action: PayloadAction<TFileCatalog>) => {
      state.fileCatalog = action.payload;
    },
    setSearchCondition: (
      state,
      action: PayloadAction<{
        [title: string]: string;
      }>,
    ) => {
      state.searchCondition = {
        ...state.searchCondition,
        ...action.payload,
      };
    },
  },
});

export const {
  setFileCatalog,
  setFlashFiles,
  setTikuFiles,
  setOneBookFiles,
  setSearchCondition,
} = fileSlice.actions;

export default fileSlice.reducer;
